import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
const siteConfig = require('./siteConfig');

// 设置文档标题
document.title = siteConfig.title;

// // 设置描述 meta 标签
// const metaDescription = document.createElement('meta');
// metaDescription.name = 'description';
// metaDescription.content = siteConfig.description;
// document.head.appendChild(metaDescription);

// // 在渲染根组件前插入广告脚本
// const adsScript = document.createElement('script');
// adsScript.async = true;
// adsScript.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3020946249293516';
// adsScript.crossOrigin = 'anonymous';

// // 防止重复添加
// if (!document.querySelector('script[src*="adsbygoogle.js"]')) {
//   document.head.appendChild(adsScript);
// }

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);